import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import CustomPageHeader from "../components/pages/CustomPageHeader";

const Language = () => {
  const { i18n, t } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState(i18n.language);

  const languages = [
    { code: "en", name: t("english") },
    { code: "sp", name: t("spanish") },
    // { code: 'es', name: 'Español' },
    // { code: 'de', name: 'Deutsch' }
  ];

  const handleLanguageChange = (languageCode) => {
    setSelectedLanguage(languageCode);
    i18n.changeLanguage(languageCode);
  };

  return (
    <>
      <CustomPageHeader
        // hideBack={true}
        // showPageHeader={false}
        // custom
        pageContainerClass=""
        title={t("change_language", "notifications")}
      >
        {/* Language selection */}
        <div className="bg-white rounded-xl p-4">
          <div className="mb-4">
            <h2 className="font-semibold mb-2 text-gray-700">
              {t("select_your_preferred_language")}
            </h2>

            <div className="space-y-2">
              {languages.map((language) => (
                <div
                  key={language.code}
                  className="text-gray-700 flex items-center justify-between p-3 border border-gray-200 rounded-lg cursor-pointer hover:bg-gray-200 transition"
                  onClick={() => handleLanguageChange(language.code)}
                >
                  <span>{language.name}</span>
                  {selectedLanguage === language.code && (
                    <FontAwesomeIcon
                      icon={faCheck}
                      className="text-green-500"
                    />
                  )}
                </div>
              ))}
            </div>

            <p className="text-sm text-gray-500 mt-4">
              {t(
                "changing_the_language_will_translate_the_app_interface_to_your_selected_language"
              )}
            </p>
          </div>
        </div>
      </CustomPageHeader>
    </>
  );
};

export default Language;
